// This can be a nice hook where we can store all the types of Forms right now;
// And what they should include
// So we are passing here name of the form, and getting back list of components that should include
// in the form. Just array with strings. Then we are passing back to useLeadsBuilder this array
const useListOfForms = (formName: string | null) => {
  const generalForm = [
    'topicOfInterest',
    'firstName',
    'lastName',
    'zipCode',
    'email',
    'preferredContactMethod',
  ];
  const tradeInForm = [
    'tradeInVehicleYear',
    'tradeInVehicleMake',
    'tradeInVehicleModel',
    'tradeInVehicleTrimLine',
    'tradeInVehicleMileage',
    'tradeInVehicleVin',
    'firstName',
    'lastName',
    'zipCode',
    'email',
    'preferredContactMethod',
  ];
  if (formName === 'contact-dealer')
    return ['firstName', 'lastName', 'zipCode', 'email', 'preferredContactMethod'];
  if (formName === 'test-drive')
    return ['firstName', 'lastName', 'zipCode', 'email', 'preferredContactMethod'];
  if (formName === 'general') return generalForm;
  if (formName === 'tradeIn') return tradeInForm;

  return generalForm;
};

export default useListOfForms;
